var map = {
	"./circle-1.png": 51009,
	"./circle-10.png": 19599,
	"./circle-11.png": 89189,
	"./circle-12.png": 316,
	"./circle-17.png": 99205,
	"./circle-4.png": 36585,
	"./circle-6.png": 33977,
	"./circle-7.png": 3964
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77772;